import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_VALUE_LIST_BY_TYPE } from "../graphql/valuelist-gql";
import { IValueInfo, IValueListByTypeResponse } from "../types/valuelist";
import { castToNumber, trimToEmpty } from "../utils/commons";

export const getValueInfo = (valueList: IValueInfo[], id?: number) =>
  valueList.find(v => +v.id === castToNumber(id));

export const getValueLabel = (valueList: IValueInfo[], id?: number) =>
  getValueInfo(valueList, id)?.label;

export default function useValueList(type?: string, activeOnly = false): [
  valueList: IValueInfo[]
] {
  const [getValueListByType] = useLazyQuery<IValueListByTypeResponse>(GET_VALUE_LIST_BY_TYPE);

  const [valueList, setValueList] = useState<IValueInfo[]>([]);

  useEffect(() => {
    const group = trimToEmpty(type);
    if (!group) {
      return;
    }

    getValueListByType({
      variables: {
        type: group
      }
    }).then(response => setValueList(response.data?.getValueListByType ?? []));
  }, [type]);

  return [activeOnly ? valueList.filter(v => v.active) : valueList];
}
